import { omit } from 'lodash';
import { apolloClient } from '~/apollo-client';
import {
  Flex_CreateFunnelPacketMutation,
  Flex_CreateFunnelPacketMutationVariables,
} from '~/typings/graphql';
import { FetchFunnelPacketResponse } from '../fetch-funnel-packet';
import { CREATE_FUNNEL_PACKET } from './create-funnel-packet.queries';

export const createFunnelPacket = async (
  params: CreateFunnelPacketParams,
): Promise<CreateFunnelPacketResponse> => {
  const input: CreateFunnelPacketParams = {
    accountId: params.accountId,
    utilityId: params.utilityId,
  };
  const { data } = await apolloClient.mutate<
    Flex_CreateFunnelPacketMutation,
    Flex_CreateFunnelPacketMutationVariables
  >({
    mutation: CREATE_FUNNEL_PACKET,
    variables: { input },
  });

  return {
    nonLmi: false,
    inviteCode: data!.createFunnelPacket.inviteCode,
    account: data!.createFunnelPacket.utilityAccount.account,
    customPlan: omit(data!.createFunnelPacket.customPlan, ['planTemplate']),
    planTemplate: data!.createFunnelPacket.customPlan.planTemplate,
    signedContractIds: data!.createFunnelPacket.signedContractIds,
    utilityAccount: omit(data!.createFunnelPacket.utilityAccount, [
      'account',
      'utilityCredential',
      'user',
      'utility',
    ]),
    utility: data!.createFunnelPacket.utilityAccount.utility,
    onboardingRateClasses: data!.createFunnelPacket.onboardingRateClasses,
    utilityCredential: data!.createFunnelPacket.utilityAccount.utilityCredential,
    user: {
      ...omit(data!.createFunnelPacket.utilityAccount.user, ['signupPromoCode']),
      promoCode: data!.createFunnelPacket.utilityAccount.user.signupPromoCode?.code,
    },
  };
};

export type CreateFunnelPacketParams = {
  utilityId: number;
  accountId: number;
};

export type CreateFunnelPacketResponse = FetchFunnelPacketResponse;
